import React, { useEffect, useState } from 'react'
import ProfilePicture from '../App/ProfilePicture';
import XCircle from '../Icons/solid/XCircle';
import useUsers from '../../store/users/usersContext';

function CollaboratorCard({ collaborator, key, onDelete, userAccount }) {

    const [ partnerInfo, setPartnerInfo ] = useState({})
    const { getPartnerInfo } = useUsers();

    useEffect(() => {
        getPartnerInfo(collaborator.user_id._id).then(res => setPartnerInfo(res.data.data));
    }, []);

  return (
    <div key={key} className="flex justify-between bg-gray-100 p-4 rounded-lg">
        <div className='mr-4'>
            <ProfilePicture user={collaborator.user_id}/>
        </div>
        <div className='w-1/3'>
            <span className="text-secondary ml-2 font-extrabold">First name</span>
            <p className="text-secondary ml-2">{collaborator.user_id.first_name}</p>
        </div>
        <div className='w-1/3'>
            <span className="text-secondary ml-2 font-extrabold">Last name</span>
            <p className="text-secondary ml-2">{collaborator.user_id.last_name}</p>
        </div>
        <div className='w-1/3'>
            <span className="text-secondary ml-2 font-extrabold">Practice</span>
            <p className="text-secondary ml-2">{partnerInfo?.type}</p>
        </div>
        <div>
            {userAccount?.isAdmin && 
            <div className='justify-between flex'>
                {onDelete && <XCircle className='cursor-pointer' onClick={() => onDelete(collaborator)} fill={'rgba(209, 213, 219, 1)'} aria-hidden="true" />}
            </div>
            }
        </div>
    </div>
  )
}

export default CollaboratorCard